/**
 * Created by Simon Zhao on 05/20/2022.
 * Description:
 * Defines models used by DashboardEditorSubChromeComponent.
 * ------ maintenance history ------
 */
import { Subject } from 'rxjs';
import { SavedDashboard } from '../../../../models/saved-screen';

export enum DashboardEditorSubChromeEventType {
    changeData,
    changeInfo,
    setFoucsValue,
    setFocusValueStore,
    setLoadingStatus,
    editTile
}

export enum DashboardEditorSubChromeActionType {
    refreshScreen,
    onFinderValueChange,
    saveGridLayout,
    onSave
}

export class DashboardEditorSubChromeConfig {
    actions$: Subject<{ type: DashboardEditorSubChromeActionType, payload?: any }>;
    clearStoreFocusValue: boolean;
    changeRouterBySelf: boolean;
    events$: Subject<{ type: DashboardEditorSubChromeEventType, payload?: any }>;
    fromPage: string;
    storeKey: string;
    screenData: SavedDashboard;
    constructor() {
        this.clearStoreFocusValue = true;
        this.changeRouterBySelf = false;
        this.events$ = new Subject();
        this.actions$ = new Subject();
        this.fromPage = '';
    }
}
